"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SourceListItem = require("./SourceListItem.styled");
var SourceListWrapper = function SourceListWrapper(_ref) {
  var dataTestId = _ref.dataTestId,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_SourceListItem.SourceListItemWrapper, {
    "data-testid": dataTestId
  }, children);
};
SourceListWrapper.propTypes = {
  dataTestId: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var _default = exports["default"] = SourceListWrapper;